import React from "react";
import {
    Instagram,
    Facebook,
    Mail,
    Phone,
    MapPin,
    Globe,
    Heart,
} from "lucide-react";

import styles from "./SocialContact.module.css";
import type { contactInfo, quickLink, socialLink } from "./types.props";
import { SocialCard } from "./SocialContact/SocialCard";
import { ContactCard } from "./SocialContact/ContactCard";
import { QuickLinkCard } from "./SocialContact/QuickLinkCard";
import HomeHeader from "./HomeHeader";

export const socialLinks: socialLink[] = [
    {
        id: 1,
        name: "Instagram",
        username: "@educontinua.ingenieriasutp",
        url: "https://www.instagram.com/educontinua.ingenieriasutp/",
        icon: Instagram,
        colorClass: "instagram",
        description: "",
    },
    {
        id: 2,
        name: "Facebook",
        username: "Educación Continua UTP - Facultad de Ingenierías",
        url: "https://www.facebook.com/EducacionContinuaUTP",
        icon: Facebook,
        colorClass: "twitter",
        description: "",
    },
];

export const contactInf: contactInfo[] = [
    {
        id: 1,
        type: "email",
        label: "Email",
        value: "extension.ingenierias@utp.edu.co",
        icon: Mail,
        colorClass: "email",
    },
    {
        id: 2,
        type: "whatsapp",
        label: "WhatsApp",
        value: "+57 304 121 2711",
        icon: Phone,
        colorClass: "phone",
    },
    {
        id: 3,
        type: "location",
        label: "Ubicación",
        value: "UTP: Bloque 1D: Facultad de ingenierías, Pereira, Colombia",
        icon: MapPin,
        colorClass: "location",
    },
];

export const quickLinks: quickLink[] = [
    {
        id: 1,
        name: "Facultad de ingenierías UTP",
        url: "https://ingenierias.utp.edu.co/",
        icon: Globe,
        description: "",
    },
];
const SocialContactPage: React.FC = () => {
    const handleSocialClick = (url: string): void => {
        window.open(url, "_blank", "noopener,noreferrer");
    };

    const handleContactClick = (
        type: contactInfo["type"],
        value: string,
    ): void => {
        const cleanedNumber = value.replace(/\D/g, "");

        switch (type) {
            case "email":
                window.location.href = `mailto:${value}`;
                break;
            case "whatsapp":
                window.open(`https://wa.me/${cleanedNumber}`, "_blank");
                break;
            case "location":
                window.open(
                    `https://maps.google.com?q=${encodeURIComponent(value)}`,
                    "_blank",
                );
                break;
            default:
                console.warn("Tipo de contacto no reconocido:", type);
        }
    };

    return (
        <div className={styles.page}>
            <div className={styles.container}>
                <HomeHeader />
                <header className={styles.header}>
                    <h1 className={styles.title}>
                        Conecta con{" "}
                        <span className={styles["title-highlight"]}>Nosotros</span>
                    </h1>
                    <p className={styles.subtitle}>
                        Mantente al día con todas nuestras redes sociales y encuentra la
                        mejor manera de contactarnos.
                    </p>
                    <div className={styles.divider} />
                </header>

                <section className={styles.section}>
                    <h2 className={styles["section-title"]}>
                        Síguenos en redes sociales
                    </h2>
                    <div className={styles.grid}>
                        {socialLinks.map((social) => (
                            <SocialCard
                                key={social.id}
                                social={social}
                                onClick={handleSocialClick}
                            />
                        ))}
                    </div>
                </section>

                <section className={styles.section}>
                    <h2 className={styles["section-title"]}>Información de contacto</h2>
                    <div className={styles.grid}>
                        {contactInf.map((contact) => (
                            <ContactCard
                                key={contact.id}
                                contact={contact}
                                onClick={handleContactClick}
                            />
                        ))}
                    </div>
                </section>

                <section className={styles.section}>
                    <h2 className={styles["section-title"]}>Enlaces útiles</h2>
                    <div className={styles["quick-link-grid"]}>
                        {quickLinks.map((link: quickLink) => (
                            <QuickLinkCard
                                key={link.id}
                                link={link}
                                onClick={handleSocialClick}
                            />
                        ))}
                    </div>
                </section>

                <footer className={styles.footer}>
                    <div className={styles["footer-content"]}>
                        <Heart className={styles["heart-icon"]} />
                        <span>
                            Visualiza, compara y optimiza tu rendimiento académico con EDUDATA
                        </span>
                    </div>
                </footer>
            </div>
        </div>
    );
};

export default SocialContactPage;
